import Big from 'big.js';

export type DecimalInput = number | string | Decimal | Big;

export class Decimal {
  private readonly value: Big;

  constructor(input: DecimalInput) {
    if (input instanceof Decimal) {
      return input;
    }

    this.value = new Big(input);
  }

  public add(other: DecimalInput): Decimal {
    const v = new Decimal(other);
    return new Decimal(this.value.plus(v.value));
  }

  public sub(other: DecimalInput): Decimal {
    const v = new Decimal(other);
    return new Decimal(this.value.minus(v.value));
  }

  public mul(other: DecimalInput): Decimal {
    const v = new Decimal(other);
    return new Decimal(this.value.times(v.value));
  }

  public div(other: DecimalInput): Decimal {
    const v = new Decimal(other);
    return new Decimal(this.value.div(v.value));
  }

  public toNumber(): number {
    return this.value.toNumber();
  }

  public toString(): string {
    return this.value.toString();
  }

  public toFixed(dp: number): string {
    return this.value.toFixed(dp);
  }
}
